export default "__VITE_ASSET__HGyUv0mg__"